import Modal from '@/components/shared/ModalV1/Modal.component';
import { Dispatch, SetStateAction } from 'react';
import { CarDetailsHeader } from '../../CarDetailsHeader/car-details-header';
import { CarDetailsType } from '@/types';
import { CarTypeDescription } from './car-type-desc';
import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { CarIncludesDetailedItems } from './car-includes-detailed-items';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { useTranslation } from 'react-i18next';
import { AvailableCarIncludes, CarIncludesMap } from '../car-includes.type';

export const CarIncludeModal = ({
    openModal,
    setOpenModal,
    showCarDetailsHeader,
    selectedCar,
    carType,
    gradientColor,
}: {
    openModal: boolean;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
    showCarDetailsHeader: boolean;
    selectedCar: CarDetailsType;
    carType: CarTypesEnum;
    gradientColor: string;
}) => {
    const { t, i18n } = useTranslation();
    const requiredIncludes = CarIncludesMap[carType];
    const toBeIncluded = requiredIncludes.map(i => AvailableCarIncludes[i]);
    return (
        <Modal
            open={openModal}
            setOpen={setOpenModal}
            header={
                showCarDetailsHeader ? (
                    <CarDetailsHeader
                        title={t('CarProfile.CarBenefits')}
                        selectedCar={selectedCar}
                        carType={carType}
                    />
                ) : (
                    <div />
                )
            }
            className={`!rounded-xl w-[${
                toBeIncluded.length > 6
                    ? 77
                    : toBeIncluded.length === 4
                    ? 50
                    : 60
            }%]`}
            style={{
                maxWidth:
                    toBeIncluded.length > 6
                        ? '77%'
                        : toBeIncluded.length === 4
                        ? '50%'
                        : '60%',
                background: `linear-gradient(180deg, ${gradientColor} 0%, rgba(245, 254, 255, 0) 32%), #FFF`,
            }}
        >
            <div className="h-full w-full flex flex-col relative">
                <div
                    className={`flex flex-col px-6 py-2 ${
                        carType === CarTypesEnum.Dealer && !showCarDetailsHeader
                            ? 'gap-3'
                            : 'gap-5'
                    }`}
                >
                    <div
                        className={`flex justify-between ${
                            showCarDetailsHeader ? 'md:ps-8 md:pe-12' : ''
                        }`}
                    >
                        <CarTypeDescription carType={carType} />
                    </div>

                    <CarIncludesDetailedItems
                        lang={i18n.language as AVAILABLE_LANGUAGES}
                        toBeIcluded={toBeIncluded}
                    />
                </div>
            </div>
        </Modal>
    );
};
